<script>
  import page from 'page'
  import { parse } from 'query-string'

  import { onMount } from 'svelte'

  import {fldvalsearchparams, fldvalsearchresult, currentformid, pagectxstate, user, dbAPI} from "./stores";

  import ErrorPage from './ErrorPage.svelte' 
  import FormPage from './FormPage.svelte'
  import FieldValuePage from './FieldValuePage.svelte' 
  import SubjectPage from './SubjectPage.svelte'
  import LoginPage from './LoginPage.svelte'
  import VerifyPage from './VerifyPage.svelte'

  import { getApiUrl,
           showPage,
           redirectToPage,
          fetchWithSession,
          API_URL_LIST 
        } from './util'

	let username

  let userData;
  $: {  
    userData = $user
    username = userData.username 
    console.debug('APP:userData: ', userData)
  }
  console.debug('APP:user: ', $user)

  let fdmf

  let menu

  // Element bindings
  let topmenu

  let pagectx
  $: { if (pagectx) $pagectxstate = pagectx.state }
  $: { handlePageCtxStateChange($pagectxstate) }
  function handlePageCtxStateChange(pgctxstate) {
    console.debug(pgctxstate)
    // This save will be redundant in some cases, but should not
    // present problems.
    pagectx?.save()
  }


  function handleTopMenuClick(e) {
    if (e.target.dataset.menu && menu != e.target.dataset.menu) {
      menu = e.target.dataset.menu
      if (menu === 'fldvals') {
        showPage('/fldvals', $fldvalsearchparams)
      } else if (menu === 'flderrs') {
        showPage('/flderrs')
      } else if (menu === 'form') {
        showPage('/form', { frm: $currentformid })
      } else if (menu === 'subj') {
        showPage('/subj')
      }
    }
  }


async function checkSessionToken() {
    try {
      const res = await fetchWithSession(getApiUrl("validate-session", null, "users"), {method: "POST"});
      if (res.ok) {
        const data = await res.json();
        username = data.username;
        console.debug("retrieved username: ", username);
        let email = data.email;
        user.update((user) => ({username, email, isAuth: true}));
        console.debug("user after update: ", $user);
        console.debug("session token valid");
      }
      else{
        console.debug("session token not valid");
        user.update((user) => ({isAuth: false}));
        // redirectToPage("login");
      }
    } catch (err) {
      console.debug(err);
      // redirectToPage("/login"); 
    }
  }

  async function loadCurrentUser() {
    let res
    try {
      res = await fetchWithSession(getApiUrl('users/current'),
                        {cache: 'no-store'})
    } catch (err) {
      console.debug(err)
    }
    if (res?.ok) {
      const json = await res.json()
      console.debug("user response: ", json)
      // username = json.name

    } else {
      console.debug(res)
      res?.text().then(t => console.debug(t))
      // username = '[API error]'
    }
  }

  async function loadFdmfInstanceProfile() {
  
    let res
    try {
      console.debug('loadFdmfInstanceProfile')
      res = await fetchWithSession(getApiUrl('fdmf/instance'),
                        {cache: 'no-store'})
    } catch (err) {
      console.debug(err)
    }
    if (res?.ok) {
      fdmf = await res.json()
      console.debug(fdmf)
      // database.update((database) => ({name: fdmf.db.friendlyname}))
      
    } else {
      console.debug(res)
      res?.text().then(t => console.debug(t))
      fdmf = null
    }
  }

  onMount(function() {
    if (menu !== 'verify') {
      checkSessionToken();
    }
    dbAPI.update((dbAPI) => API_URL_LIST[dbID]);
    console.debug("Hi ", $dbAPI);
    // loadCurrentUser()
    // loadFdmfInstanceProfile()
  })

  async function showFieldsPage(ctx, next) {
    console.debug('route /fldvals')
    pagectx = ctx
    console.debug(ctx.state.selectedRow)
    menu = 'fldvals'
  }

  async function showFormPage(ctx, next) {
    console.debug('route /form')
    pagectx = ctx
    menu = 'form'
  }

  async function showErrorsPage(ctx, next) {
    console.debug('route /flderrs')
    pagectx = ctx
    menu = 'flderrs'
    await loadFdmfInstanceProfile()
  }

  function showSubjectPage(ctx, next) {
    console.debug('route /subj')
    pagectx = ctx
    menu = 'subj'
  }

  function showLoginPage(ctx, next) {
    console.debug('route /login')
    pagectx = ctx
    menu = 'login'
  }

  function showVerifyPage(ctx, next) {
    console.debug('route /verify')
    pagectx = ctx
    menu = 'verify'
  }

  async function handleLogoutClick() {
    try {
      const res = await fetchWithSession(getApiUrl("logout", null, "users"), {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include"
      });
      if (res.ok) {
        console.debug("logout successful");
      } else {
        console.debug("logout failed");
      }
    } catch (err) {
      console.debug(err);
    }

    user.update((user) => ({isAuth: false}));
    redirectToPage("login");
  }

  let dbID = $dbAPI?.id || 0;

  async function handleDbChange(){
    console.debug("handleDbChange");
    console.log("dbID: ", dbID);
    console.log("API_URL_LIST: ", API_URL_LIST)
    dbAPI.update((dbAPI) => API_URL_LIST[dbID]);
    //dbAPI.update((dbAPI) => API_URL_LIST.find(item => item.id === dbID));
    console.log("dbAPI: ", $dbAPI);
    page.redirect('/subj')
    page.redirect('/flderrs')
    // refresh current page
    
    // await loadFdmfInstanceProfile();
  }

  page('*', (ctx, next) => { console.debug('route * first', ctx.path);
                             next() })
  page('/', () => redirectToPage('login'))
  page('/flderrs', showErrorsPage)
  page('/fldvals', showFieldsPage)
  page('/form', showFormPage)
  page('/subj', showSubjectPage)
  page('/login', showLoginPage)
  page('/verify', showVerifyPage)
  page('*', () => console.debug('route * last'))
  page.start()

  // TODO: Simple nav bar: https://linguinecode.com/post/create-a-navbar-in-svelte
  //       Much simpler: https://svelte.dev/repl/d638cbf8c52c4534ae5a7e44c3aa8323?version=3.17.1

console.log(API_URL_LIST)
</script>

<svelte:window
  on:keydown={ e => {
    // Spacebar clicks
    if (e.key === ' ') {
      const activel = document.activeElement
      if ( ['BUTTON','LI'].includes(activel.tagName) ) {
        activel.click()
        e.preventDefault()
      }
      if ( ['TR'].includes(activel.tagName) ) {
        // Because the logic is now in handleMouseDownRow...
        activel.dispatchEvent(new Event('mousedown'))
        e.preventDefault()
      }
    }
  }} />

<header>
    <ul id=topmenu bind:this={topmenu} on:click={handleTopMenuClick} on:keydown={() => {}} on:keyup={() => {}} on:keypress={() => {}}>
      <li tabindex=-1 data-menu=flderrs class:selected={menu=='flderrs'}>Errors</li>
      <li tabindex=-1 data-menu=fldvals class:selected={menu=='fldvals'}>Field values</li>
      <li tabindex=-1 data-menu=form class:selected={menu=='form'}>Form</li>
      <li tabindex=-1 data-menu=subj class:selected={menu=='subj'}>Participant</li>
    </ul>
  {#if username}
    <div class="db">
      <span> Database </span> 
        <select class="name" bind:value={dbID} on:change|preventDefault={handleDbChange}>
          {#each API_URL_LIST as option}
          <option value={option.id}>{option.name}</option>
        {/each}
        </select>
    </div>
    <div class="user">
      User <br><span class="name">{username || ""}</span>
    </div>
    <div>
      <button on:click={handleLogoutClick}>Logout</button>
    </div>
  {:else}
    <div>
      <button on:click={()=> page.redirect('/login')}>Login</button>
    </div>
  {/if}
</header>

<main>
  <!-- show loading  -->

  {#if menu === 'fldvals'}
    <FieldValuePage />
  {:else if menu === 'flderrs'}
    <ErrorPage />
  {:else if menu === 'form'}
    <FormPage />
  {:else if menu === 'subj'}
    <SubjectPage />
  {:else if menu === 'login'}
    <LoginPage {userData} />
  {:else if menu === 'verify'}
    <VerifyPage />
  {/if}
</main>

<style>
  header {
    font-size: 0.9rem;
    color: #111;
    display: flex;
    font-weight: bold;
    justify-content: space-between;
    background-color: #f8f8f8;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    flex-wrap: wrap;
    align-items: center;
    padding: 0!important;
  }
  ul#topmenu {
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    font-weight: bold;
    flex: .4 .2 auto;
  }
  ul#topmenu li {
    line-height: 2.8em;
    background-color: #eeeeee;
    color: #666;
    display: block;
    margin: 0;
    padding: .5em .5em;
    text-align: center;
    flex: 1 1 auto;
  }
  ul#topmenu li:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  ul#topmenu li:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  ul#topmenu li:hover {
    color: inherit;
    filter: brightness(0.97);
  }
  ul#topmenu li.selected {
    color: inherit;
    background-color: #e7e7e7;
  }
  header .user, header .db {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: .1 1 auto;
    margin: 0 .5em;
  }
/* if width is too small, move the db name to the right */
  @media (max-width: 650px) {
    header .db, header .user {
      display: none;
    }
  }

  header .db {
    margin-left: auto;
  }

  header .name {
    color: maroon;
    font-weight: bold;
  }

  header .db select{
    /* all:unset; */
    box-shadow: unset;
    border: 1px solid #ccc;
    padding: 0.4em 0.6em;
    background-color: #ffffff;
    border-radius: 4px;
  }

  @media (min-width: 1000px) {
  header .user,
  header .db {
    flex-direction: row;
    gap: 1em;
  }
  ul#topmenu li {
    line-height: 2em;
  }
}

  header button {
    margin: 0.2em .8em;
    border: none;
    height: 2.5em;
    border-radius: 4px;
    padding: 0.5em 1em;
    font-size: 1em;
    color: #fff;
    cursor: pointer;
    align-self: center;
  }

	main {
    font-size: .8rem;
		padding: 1em;
	}
</style>
